import axiosPost from "./axiosPost";

export const merchantServicioUsuarioGet = async ({
    merchantServicioUsuarioId,
    merchantId,
}, credentials) => {
    const body = {
        service: "MerchantServicioUsuarioGet",
        params: {
            merchantServicioUsuarioId: merchantServicioUsuarioId,
            merchantId: credentials?.merchantId ?? merchantId,
            conImagen: 'Y'
        },
    };
    const result = await axiosPost(body, credentials);

    return result.result;
};
